<template>
  <div>
    <common-dialog ref="dialog" width="600px" title="删除模板" id-key="UserId" >
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="moduleName" label="模板名" min-width="120"></el-table-column>
      </el-table>

      <template slot="footer">
        <el-button type="danger" @click="del">删除</el-button>

        <!-- <el-button type="primary" @click="lodopPrint">打印</el-button> -->
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

// import {getLodop} from '@/utils/LodopFuncs'

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },

  data() {
    return {
      tableData: [],
      list: [],
    };
  },
  methods: {
    getModule(){
         let printModel = JSON.parse(localStorage.getItem('printModel'));

        if(printModel){
        this.moduleNameList = printModel.map((item) => {
            return {moduleName: item.moduleName};
        })
        }else {
            printModel = [];
        }

        this.tableData = printModel;
    },
    handleSelectionChange(list){
      this.list = list;
    },
    del(){
        let printModel = JSON.parse(localStorage.getItem('printModel'));

        for(let i = 0; i < this.list.length; ++i){
            
            for(let j = 0; j < printModel.length; ++j){
                if(printModel[j].moduleName === this.list[i].moduleName){
                    printModel.splice(j, 1);
                }
            }
        }

        localStorage.setItem('printModel', JSON.stringify(printModel));

        this.$emit('deleted')
        this.close();
    }
  },
};
</script>

<style lang="scss" scoped>
.m18x {
  margin: 18px 0;
}
</style>
